import type { StoreLanguage } from 'idt-ecommerce-api/stores/stores.models';


export function buildStorefrontLocale(language: StoreLanguage, countryCode: string): string {
  return `${language.code}-${countryCode}`;
}
